import { render, staticRenderFns } from "./CandidateList.vue?vue&type=template&id=4d6bbb0a&scoped=true"
import script from "./CandidateList.vue?vue&type=script&lang=js"
export * from "./CandidateList.vue?vue&type=script&lang=js"
import style0 from "./CandidateList.vue?vue&type=style&index=0&id=4d6bbb0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6bbb0a",
  null
  
)

export default component.exports